import { ReferenceItemDTO } from "../../../api/client";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/UiComponents/button";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { Hr } from "../../../components/Hr";
import ItemPill from "./ItemPill";

interface ManageSectionProps {
    title: string,
    items: ReferenceItemDTO[] | undefined,
    inputValue: string,
    onInputChange: (value: string) => void,
    placeholder: string,
    onAdd: (name: string) => void,
    onRemove: (id: string) => void,
    onEdit: (id: string, newName: string) => void,
}

export default function ManageSection({title, items, inputValue, onInputChange, placeholder, onAdd, onRemove, onEdit}: ManageSectionProps) {
  
  // When add button is pressed, trim whitespace, then pass correct text to onAdd method
  const handleAdd = () => {
      if (inputValue == '' || !inputValue) return;

      const trimmed = inputValue.trim();
      if (!trimmed) return;
      onAdd(trimmed);
      onInputChange("");
  };

  // Check if the current input is a duplicate name that already exists in our displayed list
  const isDuplicate = () => {
      if (!items) return false;
      if (inputValue == '' || !inputValue) return false;
      return items.some((item) => item.name!.toLowerCase() === inputValue.trim().toLowerCase())
  }

  // Read the input to filter the displayed list of items to include the text in the input
  const filteredItems = items ? items.filter((item) => {
      if (inputValue == '' || !inputValue) return items;
      
      return item.name!.toLowerCase().includes(inputValue.toLowerCase())
  }) : []

    return (
        <>
            <h2>{title}</h2>
            <div key={"name"} className="flex items-center space-x-2 py-2">
              <Input
              placeholder={placeholder}
              value={inputValue}
              onChange={(e) => {onInputChange(e.target.value)}}
              className="max-w-sm"
              >
              </Input>
              <Button
                type="button"
                className="px-7 sm:px-11 md:px-16 transition-all"
                onClick={handleAdd}
                disabled={!inputValue || isDuplicate()}
                abbr={(!inputValue || isDuplicate()) ? "Button is disabled" : "Click to add this item"}
              >
                <div className="inline-flex justify-center items-center">
                  <ArrowRightCircle className="w-5 h-5" />
                  <span className="ml-2">Add</span>
                </div>
              </Button>
            </div>
            <div className='border bg-gray-100 dark:bg-gray-600 dark:border-gray-600 rounded-lg mb-4 p-4'>
                {filteredItems && filteredItems.length > 0 
                ? <div className="flex flex-row flex-wrap items-center gap-1">
                    {filteredItems.map((item) => (
                      <ItemPill item={item} onRemove={(id) => onRemove(id)} onEdit={(id, newName) => {onEdit(id, newName)}}/>
                    ))}
                </div>
                : <p className="text-gray-400 text-xl"> No {title.toLowerCase()} {items ? 'with that name ' : ''} found, try adding {items ? 'it' : 'some'} above!</p>
                }
                <Hr/>
                <p className="text-lg text-gray-400 font-semibold text-right">
                    Displaying {filteredItems ? filteredItems.length : 0} out of {items ? items.length : 0} {title.toLowerCase()}
                </p>
            </div>
        </>
    )
}